// Classes.
import {BaseComponentLocator} from './base.component-locator';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export class CategoryLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {

  protected _catId: number = null;
  protected _catCode: string = null;

  public constructor() {
    super();
  };


  public toString(): string {
    let str: string;
    if (this.catCode === null) {
      str = 'CatNotSet';
    }
    else {
      str = this.catCode;
    }
    return str;
  }

  /**
   * catId setter/getter.
   */
  set catId(catId: number) {
    this._catId = catId;
    this._catCode = null;
  }

  get catId(): number {
    return this._catId;
  }

  /**
   * catCode setter/getter.
   */
  set catCode(catCode: string) {
    this._catCode = catCode;
    this._catId = null;
  }

  get catCode(): string {
    return this._catCode;
  }
}

